import axios from 'axios'
import firebase from 'firebase'
import { saveUserProfilePhoto } from '@/service/s3-bucket'
import {
    userCreateApi,
    userUpdateApi,
    userLoadApi,
    userRelatedProfilesApi
    // userDeleteApi,
} from '@/config/appSettings.js'

const state = {
    profileInfo: false,
    relatedProfiles: null,
    sidebarLinks: [],
    pendingGraphAuth: null,
    profilePhoto: ''
}

const getters = {
    profileStore: state => state.profileInfo,
    relatedProfileStore: state => state.relatedProfiles,
    userMenu: state => state.sidebarLinks,
    pendingAuthProfiles: state => state.pendingGraphAuth
}

const actions = {
    async storeMenu({
        commit
    }, menuData) {
        //console.log("SETTING MENU DATA", menuData)
        if (menuData.length > 0) {
            commit('setMenu', menuData)
        }
    },
    async storeRelatedProfiles({
        commit
    }, profileList) {
        //console.log("SETTING MENU DATA", menuData)
        try {
            if (profileList.length > 0) {
                commit('setRelatedProfiles', profileList)
            }
        } catch (err) {
           // console.log("THIS IS AN ERROR:", err)
        }
    },
    async storeGraphAuthProfiles({
        commit
    }, profileList) {
        //console.log("SETTING GRAPH AUTH DATA", profileList)
        if (profileList.length > 0) {
            commit('setPendingGraphProfiles', profileList)
        }
    },
    async loadProfile({
        commit
    }, callback) {

        // GET FIREBASE TOKEN
        // GET PROFILE ID 
        // MAKE PROFILE CALL

        try {
            let auth = firebase.auth().currentUser.uid

            let profileListResponse = await axios.get(`${ userLoadApi }${auth}`)
            console.log("PROFILE DATA BACKEND:", profileListResponse.data.result)
            let profileInfo = JSON.parse(JSON.stringify(profileListResponse.data.result))
            try {
                console.log("TEST LOADING", profileInfo.profileTypes)
                if (profileInfo.profileTypes.length > 0) {
                    if (profileInfo.profileTypes.indexOf("influencer") !== -1) {
                        console.log("IS INFLUENCER")
                        profileInfo.isInfluencer = true;
                    }
                    if (profileInfo.profileTypes.indexOf("client") !== -1) {
                        //console.log("IS CLIENT")
                        profileInfo.isClient = true;
                    }
                }
            } catch (err) {
                //console.log("ERROR:", err);
            }
            //console.log("GOT PROFILE INFO:", profileInfo)
            commit('storeProfileInfo', profileInfo)


        } catch (err) {
            //console.log("there as an error", err)
        }
    },
    async loadRelatedProfiles({
        commit
    }, callback) {

        // GET FIREBASE TOKEN
        // GET PROFILE ID 
        // MAKE PROFILE CALL

        try {
            let auth = firebase.auth().currentUser.uid
            let relatedProfileResponse = await axios.get(`${ userRelatedProfilesApi }/?usertoken=${auth}`)
            //console.log("PROFILE DATA:", profileData.data.result)
            commit('loadRelatedProfiles', relatedProfileResponse.data.result)

        } catch (err) {
           // console.log("there as an error", err)
        }
    },
    createProfile({
        commit
    }, profileInfo) {
        axios.post(userCreateApi, profileInfo).then(res => {
            //console.log("PROFILE CREATED SUCCESSFULLY: ", res)
            // ADD A NEW POINT ENTRY 
            if (res.data.success === true) {
                axios.post(actionCreateApi, {
                    type: 'new profile',
                    user: firebase.auth().currentUser.uid
                })
            }

            commit('createNewProfile', profileInfo)
        })
    },
    async updateProfile({
        commit
    }, profileInfo) {
        commit('storeProfileInfo', profileInfo)
    },
    async emailContactCreate() {
        let email = await firebase.auth().currentUser.email
        await axios.post(userEmailCreateApi, {
            'email': email
        })
        //console.log(createEmail)
    },
    async emailContactUpdate({
        dispatch
    }, profileUpdate) {
        await axios.post(userEmailUpdateApi, {
            email: profileUpdate.email,
            firstname: profileUpdate.firstname,
            lastname: profileUpdate.lastname,
            profile_complete: true
        })
    },
    async saveUserProfilePhoto({commit}, file) {
        const response = await saveUserProfilePhoto(file)
        return response
    }
}

const mutations = {
    createNewProfile: (state, profile) => state.profileResult = profile,
    storeProfileInfo: (state, profile) => state.profileInfo = profile,
    updateProfile: (state, profile) => state.profileInfo = profile,
    loadRelatedProfiles: (state, profileList) => state.relatedProfiles = profileList,
    setMenu: (state, menuData) => state.sidebarLinks = menuData,
    setRelatedProfiles: (state, relatedProfileList) => state.relatedProfiles = relatedProfileList,
    setPendingGraphProfiles: (state, profileList) => state.pendingGraphAuth = profileList


}

export default {
    state,
    getters,
    actions,
    mutations
}